import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { IProfanityDetails, Violation } from "src/app/interfaces/Violation.interface";
import { TrsEventsService } from "src/app/services/trsevents.service";
import { getConvertedDateTime } from "src/app/utils/timeManager";

@Component({
    selector: 'secure-assist-details-popup',
    templateUrl: './secure-assist-details-popup.html',
    styleUrls: ['./secure-assist-details-popup.sass'],
})
export class SecureAssistDetailsPopupComponent implements OnInit {
    @Input() eventDetails: Violation;
    @Input() eventDisplayName: string;

    eventLabel: string = "";
    closeLabel: string = "";
    sessionIdLabel: string = "";
    messageSourceLabel: string = "";
    originalSpeechLabel: string = "";
    profanityDetectedLabel: string = "";
    profanityAgentAudioLabel: string = "";
    profanityCustomerAudioLabel: string = "";
    callSummaryLabel: string = "";
    timestampLabel: string = "";

    constructor(private translationService: TranslocoService, private trsEventService: TrsEventsService) {
        this.updateComponentLabels();
    }

    @Output() ClosePopUpEvent: EventEmitter<any> = new EventEmitter();

    ngOnInit(): void {
        this.updateComponentLabels();
        this.trsEventService.evtDataObservable.subscribe(response => {
            switch (response.eventName) {
                case "SIGNEDMEDIAURL":
                    if (response.data.ViolationId === this.eventDetails.ViolationId && response.data.ProfanityDetails != null && response.data.ProfanityDetails.length > 0)
                        response.data.ProfanityDetails.forEach((details: IProfanityDetails) => {
                            for (const profanity of this.eventDetails.ProfanityDetails)
                                if (profanity.SubSessionId === details.SubSessionId) {
                                    if (details.LastAudioUrl != null && details.LastAudioUrl !== "")
                                        profanity.LastAudioUrl = details.LastAudioUrl;
                                    if (details.LastAudioUrlCustomer != null && details.LastAudioUrlCustomer !== "")
                                        profanity.LastAudioUrlCustomer = details.LastAudioUrlCustomer;
                                    break;
                                }
                        });
                    break;
            }
        });
    }

    updateComponentLabels = (): void => {
        this.eventLabel = this.translationService.translate("Event");
        this.closeLabel = this.translationService.translate("Close");
        this.sessionIdLabel = this.translationService.translate("Session ID");
        this.messageSourceLabel = this.translationService.translate("Message Source");
        this.originalSpeechLabel = this.translationService.translate("Original Speech");
        this.profanityDetectedLabel = this.translationService.translate("Profanity Detected");
        this.profanityAgentAudioLabel = this.translationService.translate("Agent Audio");
        this.profanityCustomerAudioLabel = this.translationService.translate("Customer Audio");
        this.callSummaryLabel = this.translationService.translate("Call Summary");
        this.timestampLabel = this.translationService.translate("Timestamp");
    }

    closePopup = (): void => {
        this.ClosePopUpEvent.emit("Close");
    }

    formatDateTime = (dateTime: string | Date | null): Date => {
        if (dateTime == null)
            return new Date();
        else return getConvertedDateTime(dateTime);
    }
}